// components/WalletDropdown.js
import React from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import { useTheme } from '../../../../hooks/ThemeProvider';

const WalletDropdown = ({

    isConnected,
    isSigningInProgress,
    isSignPending,
    isMobile,
    connectors,
    onWalletConnect
}) => {
       const { theme, toggle } = useTheme();
    if (isConnected) {
        if (isSigningInProgress) {

            return (
                <div style={{ color: 'white', fontSize: '12px', textAlign: 'center' }}>
                    {isSignPending ? (
                        <div>
                            <div>🔐 Please sign the message</div>
                            <div>in your wallet...</div>
                        </div>
                    ) : (
                        <div>🔄 Authenticating...</div>
                    )}
                </div>
            );
        }
        return null; // Don't render anything when connected and not signing
    }


    return (
        <Dropdown align="end">
            <Dropdown.Toggle
                variant="success"
                id="dropdown-basic"
                disabled={isSigningInProgress}
            >
                {isSigningInProgress ? 'Connecting...' : 'Connect Wallet'}
            </Dropdown.Toggle>
            <Dropdown.Menu>
                <div className="innner_side">
                    <div className="middleside">
                        <h3>Connect Wallet</h3>
                        <h4>Easily link your digital wallet to get started!</h4>
                    </div>

                    {[0, 1]
                        .filter((id) => !(isMobile && id === 0))
                        .map((id) => (
                            <Dropdown.Item
                                key={id}
                                as="div"
                                className="inner_Drop"
                                onClick={() => onWalletConnect(connectors[id])}
                                style={{
                                    opacity: isSigningInProgress ? 0.5 : 1,
                                    pointerEvents: isSigningInProgress ? 'none' : 'auto'
                                }}
                            >
                                <div className="inner_more">
                                    <img
                                        src={
                                            id === 0
                                                ? theme === "dark"
                                                    ? "/assets/meta.svg"
                                                    : "/assets/lightmeta.svg"
                                                : id === 3
                                                    ? theme === "dark"
                                                        ? "/assets/coin.svg"
                                                        : "/assets/lightcoin.svg"
                                                    : theme === "dark"
                                                        ? "/assets/wallet.svg"
                                                        : "/assets/lightwallet.svg"
                                        }
                                        alt="icon"
                                    />
                                    <h5>{connectors[id].name}</h5>
                                </div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                    <path d="M5.25 5.25H12.75V12.75" stroke="#515B71" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M5.25 12.75L12.75 5.25" stroke="#515B71" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </Dropdown.Item>
                        ))}

                    <p>
                        By connecting a wallet, you agree to Unifarm's{" "}
                        <span>Terms of Services </span>and consent to its{" "}
                        <span>Privacy Policy</span>
                    </p>
                </div>
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default WalletDropdown;